export interface FixShelfTypeTempChangeRequest {
  _isUpdateChildCollection: boolean
  handlingType: string
  handlingTypeErase: boolean
  collections: {
    id: number
    revision: number
  }[]
}

export function FixShelfTypeTempChangeRequestToJSON(
  value: FixShelfTypeTempChangeRequest
): any {
  return {
    _is_update_child_collection: value._isUpdateChildCollection ?? undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    handling_type_erase: value.handlingTypeErase ?? undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              revision:
                collection.revision !== 0 ? collection.revision : undefined
            }
          })
        : undefined
  }
}
